<!-- CURRENT ORDER ROW -->
<div class="order-list" *ngIf="!pastOrders">
  <ng-container
    *cdkVirtualFor="
      let item of ordersList?.myOrdersRows;
      let i = index;
      trackBy: trackItem
    "
  >
    <div #orders>
      <ng-container *ngIf="item?.rowType === rowType.TitleRow" tabindex="0"
        ><div class="date-container" data-cy="order-date-text">
          {{ item?.title | translate }}
          <ion-badge
            [ngClass]="
              item?.displayType === DisplayType.IN_PROGRESS ? 'in-progress' : ''
            "
            >{{ item.itemCount }}</ion-badge
          >
        </div>
      </ng-container>

      <ng-container
        *ngIf="
          item?.rowType === rowType.OrderRow ||
          item?.rowType === rowType.NoOrderRow
        "
        class="list-container"
        tabindex="0"
      >
        <div
          class="order-list-container"
          [ngClass]="getDisplayClass(item)"
          data-cy="open-no-order-link"
          [ngStyle]="formatOrderStatusViewed(item)"
          (click)="openOrder(item, false)"
        >
          <!-- LINKS -->
          <div
            *ngIf="
              item.displayType !== DisplayType.ORDER_CANCELLED ||
              item.orderHeader?.orderType !== 'VS'
            "
            class="action-link-group"
          >
            <div class="route-notice-alert">
              <div
                *ngIf="item?.orderHeader?.etaReasonShort?.trim()"
                class="order-notice"
                data-cy="order-notice-text"
              >
                <ion-button
                  class="button-clear"
                  (click)="
                    presentPopover($event, item?.orderHeader?.etaReasonLong)
                  "
                  ><ion-icon name="alert-circle-outline"></ion-icon
                  >{{ item?.orderHeader?.etaReasonShort }}</ion-button
                >
              </div>
            </div>

            <div class="action-link-wrapper">
              <ng-container *appShowSplit="[dynamicCookbookOrderFeatureFlag]">
                <a
                  *ngIf="displayMetricsLink(item)"
                  class="action-link"
                  data-cy="metrics-order-link"
                  (click)="openInsightsOrder(item, $event)"
                >
                  {{ 'i18n.orderStatusPage.metrics' | translate }}
                </a>
                <span
                  class="border"
                  *ngIf="
                    insightsItems(item)?.length === 0 &&
                    (item.hasETADetails ||
                      (!item.orderHeader?.orderDelivered &&
                        !!item.orderHeader.etaRoute) ||
                      (item.orderHeader.trackingAvailable &&
                        !!item.orderHeader.orderTracking?.length) ||
                      !!item.wmtDeliveryDate ||
                      !!item.orderHeader.orderDelivered ||
                      (item.orderHeader?.orderType === 'VS' &&
                        (!!item.orderHeader?.orderTracking?.length ||
                          item.orderHeader?.trackingAvailable))) &&
                    !(hideEtaGlobalFeatureFlag && item?.orderHeader?.hideEta)
                  "
                  >&nbsp; | &nbsp;</span
                >
                <span
                  class="border"
                  *ngIf="
                    insightsItems(item)?.length === 0 &&
                    item.isEditable &&
                    !hideModifyLink(
                      item,
                      (panAppState.online$ | async) === true
                    ) &&
                    !(
                      item.hasETADetails ||
                      (!item.orderHeader?.orderDelivered &&
                        !!item.orderHeader.etaRoute) ||
                      (item.orderHeader.trackingAvailable &&
                        !!item.orderHeader.orderTracking?.length) ||
                      !!item.wmtDeliveryDate ||
                      !!item.orderHeader.orderDelivered ||
                      (item.orderHeader?.orderType === 'VS' &&
                        (!!item.orderHeader?.orderTracking?.length ||
                          item.orderHeader?.trackingAvailable)) ||
                      (hideEtaGlobalFeatureFlag && item?.orderHeader?.hideEta)
                    )
                  "
                  >&nbsp; | &nbsp;</span
                >
              </ng-container>
              <div
                class="wmt-delivery-date"
                *ngIf="
                  (item.hasETADetails ||
                    (!item.orderHeader?.orderDelivered &&
                      !!item.orderHeader.etaRoute) ||
                    (item.orderHeader.trackingAvailable &&
                      !!item.orderHeader.orderTracking?.length) ||
                    !!item.wmtDeliveryDate ||
                    !!item.orderHeader.orderDelivered ||
                    (item.orderHeader?.orderType === 'VS' &&
                      (!!item.orderHeader?.orderTracking?.length ||
                        item.orderHeader?.trackingAvailable))) &&
                  !(hideEtaGlobalFeatureFlag && item?.orderHeader?.hideEta)
                "
              >
                <!-- TRACK DELIVERY LINK -->
                <a
                  class="action-link"
                  (click)="openOrder(item, false)"
                  data-cy="open-order-tracking-link"
                  >{{ 'i18n.orderStatusPage.trackDelivery' | translate }}</a
                >
              </div>

              <span
                class="border"
                *ngIf="
                  item.isEditable &&
                  (item.hasETADetails ||
                    (!item.orderHeader?.orderDelivered &&
                      !!item.orderHeader.etaRoute) ||
                    (item.orderHeader.trackingAvailable &&
                      !!item.orderHeader.orderTracking?.length) ||
                    !!item.wmtDeliveryDate ||
                    !!item.orderHeader.orderDelivered ||
                    (item.orderHeader?.orderType === 'VS' &&
                      (!!item.orderHeader?.orderTracking?.length ||
                        item.orderHeader?.trackingAvailable))) &&
                  !(hideEtaGlobalFeatureFlag && item?.orderHeader?.hideEta)
                "
                >&nbsp; | &nbsp;</span
              >

              <!-- MODIFY LINK -->
              <a
                *ngIf="
                  item.isEditable &&
                  !hideModifyLink(item, (panAppState.online$ | async) === true)
                "
                class="action-link"
                data-cy="edit-order-link"
                (click)="editSubmittedOrder(item, $event)"
              >
                {{
                  item.modifyLinkText
                    ? item.modifyLinkText
                    : ('i18n.common.modify' | translate)
                }}
              </a>

              <!-- RESUBMIT LINK -->
              <a
                *ngIf="item.displayType === DisplayType.ORDER_ERROR"
                class="action-link"
                data-cy="resubmit-order-link"
                (click)="openOrder(item, false, $event)"
              >
                {{ 'i18n.common.resubmit' | translate }}
              </a>

              <!-- RESUBMIT ORDER LINK -->
              <a
                *ngIf="item.displayType === DisplayType.SUBMISSION_ERROR"
                class="action-link red-text"
                data-cy="resubmit-submission-error-link"
                (click)="resubmitOrder(item, $event)"
                >{{ 'i18n.orderStatusPage.resubmit' | translate }}</a
              >

              <ng-container
                *ngIf="
                  (item.displayType === DisplayType.ORDER_ERROR ||
                    item.displayType === DisplayType.SUBMISSION_ERROR) &&
                  item.orderHeader?.orderType === 'RT' &&
                  isInternalUser &&
                  insightsItems(item)?.length > 0 &&
                  (panAppState.online$ | async) === true
                "
              >
                <span class="border">&nbsp; | &nbsp;</span></ng-container
              >

              <ng-container
                *ngIf="
                  item.isEditable &&
                  item.displayType === DisplayType.SUBMITTED_WITH_EXCEPTIONS &&
                  !item.restrictToOG &&
                  !hideModifyLink(item, (panAppState.online$ | async) === true)
                "
              >
                <span class="border">&nbsp; | &nbsp;</span></ng-container
              >

              <!-- CREATE ORDER LINK -->
              <ng-container *ngIf="item.displayType === DisplayType.NO_ORDER">
                <a
                  class="action-link"
                  (click)="createNewOrder(item)"
                  data-cy="create-order-link"
                >
                  {{ 'i18n.common.createOrder' | translate }}
                </a>
              </ng-container>

              <!-- RESOLVE EXCEPTIONS LINK -->
              <a
                *ngIf="
                  item.isEditable && shouldDisplayResolveExceptionsLink(item)
                "
                class="action-link"
                data-cy="resolve-exception-button"
                (click)="resolveSubmittedOrder(item, $event)"
                >{{ 'i18n.orderStatusPage.resolve' | translate }}</a
              >

              <!-- INSIGHTS ORDER LINK -->
              <ng-container *appShowSplit="[insightsOrderLinkFeatureFlag]">
                <span
                  *ngIf="
                    item.isEditable &&
                    item.orderHeader?.orderType === 'RT' &&
                    isInternalUser &&
                    insightsItems(item)?.length > 0 &&
                    (panAppState.online$ | async) === true
                  "
                  class="border"
                >
                  &nbsp; | &nbsp;
                </span>
                <a
                  *ngIf="
                    item.orderHeader?.orderType === 'RT' &&
                    isInternalUser &&
                    insightsItems(item)?.length > 0 &&
                    (panAppState.online$ | async) === true
                  "
                  class="action-link insights-action-link"
                  data-cy="insights-order-link"
                  (click)="openInsightsOrder(item, $event)"
                >
                  <span
                    class="border"
                    *ngIf="
                      (item.hasETADetails ||
                        (!item.orderHeader?.orderDelivered &&
                          !!item.orderHeader.etaRoute) ||
                        (item.orderHeader.trackingAvailable &&
                          !!item.orderHeader.orderTracking?.length) ||
                        !!item.wmtDeliveryDate ||
                        !!item.orderHeader.orderDelivered ||
                        (item.orderHeader?.orderType === 'VS' &&
                          (!!item.orderHeader?.orderTracking?.length ||
                            item.orderHeader?.trackingAvailable))) &&
                      !(hideEtaGlobalFeatureFlag && item?.orderHeader?.hideEta)
                    "
                    >&nbsp; | &nbsp;</span
                  >
                  {{ 'i18n.orderStatusPage.insights' | translate
                  }}<ion-badge
                    class="insights-badge"
                    data-cy="insights-count-badge"
                  >
                    {{
                      insightsItems(item).length > 99
                        ? 99
                        : insightsItems(item).length
                    }}
                  </ion-badge>
                </a>
              </ng-container>
            </div>
          </div>
          <div class="order-row-container">
            <div class="customer-and-action-container">
              <!-- NO ORDER ROW -->
              <ng-container *ngIf="item.displayType === DisplayType.NO_ORDER">
                <div class="order-label">
                  <div class="customer-label">
                    <div>
                      <span
                        class="customer-name"
                        data-cy="order-customer-name-text"
                      >
                        {{ item.customer?.customerName | titlecase }} &nbsp;
                      </span>
                      <span
                        class="customer-number"
                        data-cy="order-customer-number-text"
                      >
                        ({{ item.orderHeader.customerNumber }})
                      </span>
                      <span
                        class="department-number"
                        *ngIf="item.orderHeader.departmentNumber !== 0"
                        data-cy="order-customer-department-text"
                        >,
                        {{
                          'i18n.orderStatusPage.deptNumberMobile' | translate
                        }}
                        ({{ item.orderHeader.departmentNumber }})
                      </span>
                    </div>
                  </div>
                  <div>
                    <strong class="no-order-text" data-cy="no-order-text">
                      <span>
                        <img
                          class="order-icon"
                          src="assets/icon/no-order.svg"
                          alt="No Order"
                          height="20"
                        />
                      </span>
                      {{ 'i18n.orderStatusPage.noOrderStarted' | translate }}
                    </strong>
                  </div>
                </div>
              </ng-container>

              <!-- IN PROGRESS ROW -->
              <ng-container
                *ngIf="
                  item.displayType === DisplayType.IN_PROGRESS ||
                  item.displayType === DisplayType.SUBMITTING
                "
              >
                <div class="order-label">
                  <div class="customer-label">
                    <div>
                      <span
                        class="customer-name"
                        data-cy="order-customer-name-text"
                      >
                        {{ item.customer?.customerName | titlecase }} &nbsp;
                      </span>
                      <span
                        class="customer-number"
                        data-cy="order-customer-number-text"
                      >
                        ({{ item.orderHeader.customerNumber }})
                      </span>
                      <span
                        class="department-number"
                        *ngIf="item.orderHeader.departmentNumber !== 0"
                        data-cy="order-customer-department-text"
                        >,
                        {{
                          'i18n.orderStatusPage.deptNumberMobile' | translate
                        }}
                        ({{ item.orderHeader.departmentNumber }})
                      </span>
                    </div>
                  </div>
                  <div>
                    <strong
                      class="no-order-text"
                      data-cy="order-inprogress-display-text"
                    >
                      <span>
                        <img
                          [src]="item.iconUrl"
                          alt="Not Submitted"
                          class="order-icon"
                          height="20"
                        />
                      </span>
                      {{ item.displayTitle | translate }}
                      <span
                        *ngIf="item.itemInCart"
                        data-cy="order-inprogress-products-in-cart-text"
                        >({{
                          'i18n.orderStatusPage.productsInCart' | translate
                        }})</span
                      >
                    </strong>
                  </div>
                  <!-- DELIVERY DATE / ETA -->
                  <div
                    *ngIf="
                      item.orderDelivered &&
                      !!item.deliveredDtm &&
                      !(hideEtaGlobalFeatureFlag && item?.orderHeader?.hideEta)
                    "
                    data-cy="open-order-item-link"
                    class="delivery-date date"
                  >
                    {{ 'i18n.orderStatusPage.delivered' | translate }}
                    {{
                      item.deliveredDtm
                        | timezoneDate: 'M/D' : item.customer?.timeZone
                    }},
                    {{
                      item.deliveredDtm
                        | timezoneDate
                          : 'h:mm a'
                          : item.customer?.timeZone ?? 'CT'
                          : true
                    }}
                  </div>
                  <div
                    *ngIf="
                      item?.hasETADetails &&
                        item?.orderHeader?.deliveryEta &&
                        isValidDate(item?.orderHeader?.deliveryEta) &&
                        !(
                          hideEtaGlobalFeatureFlag && item?.orderHeader?.hideEta
                        );
                      else checkETARouteDetails
                    "
                    data-cy="open-order-item-link"
                    class="delivery-date"
                  >
                    <span class="date"
                      >{{ 'i18n.orderStatusPage.eta' | translate }}
                      {{
                        item?.orderHeader?.deliveryEta
                          | date: 'M/d' : item.customer?.timeZone
                      }}
                      <b
                        *ngIf="
                          !!item?.orderHeader?.etaRangeMaximum &&
                          !!item?.orderHeader?.etaRangeMinimum
                        "
                        >,
                        {{
                          item?.orderHeader?.etaRangeMinimum
                            | timezoneDate
                              : 'h:mm a'
                              : item.customer?.timeZone ?? 'CT'
                        }}
                        -
                        {{
                          item?.orderHeader?.etaRangeMaximum
                            | timezoneDate
                              : 'h:mm a'
                              : item.customer?.timeZone ?? 'CT'
                              : true
                        }}
                      </b></span
                    >
                    <span
                      class="date"
                      *ngIf="!!item?.orderHeader?.customerStop"
                    >
                      {{ 'i18n.orderStatusPage.youAreStop' | translate }}
                      {{ item?.orderHeader?.customerStop }}
                    </span>
                    <span class="date" *ngIf="!!item?.orderHeader?.etaRoute">
                      {{ 'i18n.orderStatusPage.onRoute' | translate }}
                      {{ item?.orderHeader?.etaRoute }}
                    </span>
                    <span
                      class="date"
                      *ngIf="
                        !!item?.orderHeader?.currentStop &&
                        item?.orderHeader?.etaMessageType !==
                          orderETAMessageType.PLANNED &&
                        (!!item?.orderHeader?.customerStop ||
                          !!item?.orderHeader?.etaRoute)
                      "
                      >,</span
                    >
                    <span
                      class="date"
                      *ngIf="
                        !!item?.orderHeader?.currentStop &&
                        item?.orderHeader?.etaMessageType !==
                          orderETAMessageType.PLANNED
                      "
                    >
                      {{ 'i18n.orderStatusPage.truckAtStop' | translate
                      }}{{ item?.orderHeader?.currentStop }}</span
                    >
                  </div>
                  <ng-template #checkETARouteDetails>
                    <div
                      class="delivery-date"
                      *ngIf="!item?.orderHeader?.orderDelivered"
                    >
                      <div class="eta">
                        <span
                          class="date"
                          *ngIf="
                            item?.orderHeader?.deliveryEta &&
                              isValidDate(item?.orderHeader?.deliveryEta) &&
                              !(
                                hideEtaGlobalFeatureFlag &&
                                item?.orderHeader?.hideEta
                              );
                            else deliveryDateAsETA
                          "
                        >
                          {{ 'i18n.orderStatusPage.eta' | translate }}
                          {{
                            item.orderHeader?.deliveryEta
                              | date: 'M/d' : item.customer?.timeZone
                          }}
                        </span>
                        <ng-template #deliveryDateAsETA>
                          <span
                            *ngIf="
                              isValidDate(item.deliveryDate) &&
                                ((item.orderStatusDisplayEnabled &&
                                  item.orderHeader?.orderType === 'VS') ||
                                  !(
                                    item.orderHeader?.orderType === 'VS' &&
                                    (!!item.orderHeader?.orderTracking
                                      ?.length ||
                                      item.orderHeader?.trackingAvailable)
                                  ));
                              else deliveryDateAsETANotApplicable
                            "
                            class="date"
                          >
                            {{ 'i18n.orderStatusPage.eta' | translate }}
                            {{ item.deliveryDate | date: 'M/d' : 'GMT' }}
                          </span>
                          <ng-template #deliveryDateAsETANotApplicable>
                            <span
                              class="date"
                              *ngIf="
                                !(
                                  item.orderHeader?.orderType === 'VS' &&
                                  (!!item.orderHeader?.orderTracking?.length ||
                                    item.orderHeader?.trackingAvailable)
                                ) &&
                                item?.orderHeader?.orderStatus !==
                                  OrderStatus.ORDER_CANCELLED &&
                                item?.orderHeader?.displayOrderStatus !==
                                  OrderStatus.DELIVERED
                              "
                            >
                              {{
                                'i18n.orderStatusPage.notApplicable' | translate
                              }}
                            </span>
                          </ng-template>
                        </ng-template>
                        <br />
                        <ng-container
                          *ngIf="
                            !(
                              hideEtaGlobalFeatureFlag &&
                              item?.orderHeader?.hideEta
                            )
                          "
                        >
                          <span
                            class="date"
                            *ngIf="!!item?.orderHeader?.customerStop"
                          >
                            {{ 'i18n.orderStatusPage.youAreStop' | translate }}
                            {{ item?.orderHeader?.customerStop }}
                          </span>
                          <span
                            class="date"
                            *ngIf="!!item?.orderHeader?.etaRoute"
                          >
                            {{ 'i18n.orderStatusPage.onRoute' | translate }}
                            {{ item?.orderHeader?.etaRoute }}
                          </span>
                          <span
                            class="date"
                            *ngIf="
                              !!item?.orderHeader?.currentStop &&
                              item?.orderHeader?.etaMessageType !==
                                orderETAMessageType.PLANNED &&
                              (!!item?.orderHeader?.customerStop ||
                                !!item?.orderHeader?.etaRoute)
                            "
                            >,</span
                          >
                          <span
                            class="date"
                            *ngIf="
                              !!item?.orderHeader?.currentStop &&
                              item?.orderHeader?.etaMessageType !==
                                orderETAMessageType.PLANNED
                            "
                          >
                            {{ 'i18n.orderStatusPage.truckAtStop' | translate
                            }}{{ item?.orderHeader?.currentStop }}</span
                          >
                        </ng-container>
                      </div>
                    </div>
                  </ng-template>
                  <div
                    *ngIf="
                      item.orderDelivered &&
                      !item.deliveredDtm &&
                      item.deliveryDate !== 'Invalid Date' &&
                      item.displayType !== DisplayType.NO_ORDER &&
                      item.deliveryDate !== 'N/A'
                    "
                    data-cy="open-order-item-link"
                    class="delivery-date date"
                  >
                    {{ item.deliveryDate | date: 'M/d' : 'GMT' }}
                  </div>
                  <div
                    *ngIf="
                      item.orderDelivered &&
                      item.deliveredDtm &&
                      item.deliveryDate !== 'Invalid Date' &&
                      item.displayType !== DisplayType.NO_ORDER &&
                      item.deliveryDate !== 'N/A' &&
                      hideEtaGlobalFeatureFlag &&
                      item?.orderHeader?.hideEta
                    "
                    data-cy="open-order-item-link"
                    class="delivery-date date"
                  >
                    {{ 'i18n.orderStatusPage.eta' | translate }}
                    {{ item.deliveryDate | date: 'M/d' : 'GMT' }}
                  </div>
                  <div
                    *ngIf="
                      item.orderDelivered &&
                      !item.deliveredDtm &&
                      item.deliveryDate !== 'Invalid Date' &&
                      item.displayType !== DisplayType.NO_ORDER &&
                      item.deliveryDate === 'N/A'
                    "
                    data-cy="open-order-item-link"
                    class="delivery-date"
                  >
                    {{ 'i18n.orderStatusPage.notApplicable' | translate }}
                  </div>
                </div>
              </ng-container>

              <!-- NO SUBMITTED ROW -->
              <ng-container
                *ngIf="
                  item.displayType === DisplayType.SUBMITTED ||
                  item.displayType === DisplayType.OUT_FOR_DELIVERY ||
                  item.displayType === DisplayType.QUANTITIES_UPDATED ||
                  item.displayType === DisplayType.ATTEMPTED_DELIVERY ||
                  item.displayType === DisplayType.DELIVERED ||
                  item.displayType === DisplayType.PREPARING_TO_SHIP
                "
              >
                <div class="order-label">
                  <div class="customer-label">
                    <div>
                      <span
                        class="customer-name"
                        data-cy="order-customer-name-text"
                      >
                        {{ item.customer?.customerName | titlecase }} &nbsp;
                      </span>
                      <span
                        class="customer-number"
                        data-cy="order-customer-number-text"
                      >
                        ({{ item.orderHeader.customerNumber }})
                      </span>
                      <span
                        class="department-number"
                        *ngIf="item.orderHeader.departmentNumber !== 0"
                        data-cy="order-customer-department-text"
                        >,
                        {{
                          'i18n.orderStatusPage.deptNumberMobile' | translate
                        }}
                        ({{ item.orderHeader.departmentNumber }})
                      </span>
                    </div>
                  </div>
                  <div>
                    <strong
                      data-cy="order-submitted-display-text"
                      class="green-text"
                    >
                      <span>
                        <img
                          [src]="item.iconUrl"
                          alt="Order Error"
                          class="order-icon"
                          height="20"
                        />
                      </span>
                      {{ item.displayTitle | translate }}
                      <span
                        *ngIf="item?.orderHeader?.orderType !== 'VS'"
                        data-cy="order-submitted-order-type-text"
                        class="order-type-text"
                      >
                        &nbsp;| &nbsp;{{
                          getOrderHeaderTxt(item.orderHeader) | translate
                        }}
                      </span>
                      <span
                        *ngIf="item?.orderHeader?.orderType === 'VS'"
                        data-cy="order-exceptions-order-direct-image"
                        class="order-type-text"
                      >
                        &nbsp;|
                        <img
                          src="assets/icon/direct-no-outline.svg"
                          class="direct-icon"
                          alt="Direct Order"
                          height="10"
                        />
                        {{ 'i18n.orderStatusPage.shipping' | translate }}
                      </span>
                    </strong>
                  </div>

                  <!-- DELIVERY DATE / ETA -->
                  <div
                    *ngIf="
                      item.orderDelivered &&
                      !!item.deliveredDtm &&
                      !(hideEtaGlobalFeatureFlag && item?.orderHeader?.hideEta)
                    "
                    data-cy="open-order-item-link"
                    class="delivery-date date"
                  >
                    {{ 'i18n.orderStatusPage.delivered' | translate }}
                    {{
                      item.deliveredDtm
                        | timezoneDate: 'M/D' : item.customer?.timeZone
                    }},
                    {{
                      item.deliveredDtm
                        | timezoneDate
                          : 'h:mm a'
                          : item.customer?.timeZone ?? 'CT'
                          : true
                    }}
                  </div>
                  <div
                    *ngIf="
                      item?.hasETADetails &&
                        item?.orderHeader?.deliveryEta &&
                        isValidDate(item?.orderHeader?.deliveryEta) &&
                        !(
                          hideEtaGlobalFeatureFlag && item?.orderHeader?.hideEta
                        );
                      else checkETARouteDetails
                    "
                    data-cy="open-order-item-link"
                    class="delivery-date"
                  >
                    <span class="date"
                      >{{ 'i18n.orderStatusPage.eta' | translate }}
                      {{
                        item?.orderHeader?.deliveryEta
                          | date: 'M/d' : item.customer?.timeZone
                      }}
                      <b
                        *ngIf="
                          !!item?.orderHeader?.etaRangeMaximum &&
                          !!item?.orderHeader?.etaRangeMinimum
                        "
                        >,
                        {{
                          item?.orderHeader?.etaRangeMinimum
                            | timezoneDate
                              : 'h:mm a'
                              : item.customer?.timeZone ?? 'CT'
                        }}
                        -
                        {{
                          item?.orderHeader?.etaRangeMaximum
                            | timezoneDate
                              : 'h:mm a'
                              : item.customer?.timeZone ?? 'CT'
                              : true
                        }}
                      </b></span
                    >
                    <span
                      class="date"
                      *ngIf="!!item?.orderHeader?.customerStop"
                    >
                      {{ 'i18n.orderStatusPage.youAreStop' | translate }}
                      {{ item?.orderHeader?.customerStop }}
                    </span>
                    <span class="date" *ngIf="!!item?.orderHeader?.etaRoute">
                      {{ 'i18n.orderStatusPage.onRoute' | translate }}
                      {{ item?.orderHeader?.etaRoute }}
                    </span>
                    <span
                      class="date"
                      *ngIf="
                        !!item?.orderHeader?.currentStop &&
                        item?.orderHeader?.etaMessageType !==
                          orderETAMessageType.PLANNED &&
                        (!!item?.orderHeader?.customerStop ||
                          !!item?.orderHeader?.etaRoute)
                      "
                      >,</span
                    >
                    <span
                      class="date"
                      *ngIf="
                        !!item?.orderHeader?.currentStop &&
                        item?.orderHeader?.etaMessageType !==
                          orderETAMessageType.PLANNED
                      "
                    >
                      {{ 'i18n.orderStatusPage.truckAtStop' | translate
                      }}{{ item?.orderHeader?.currentStop }}</span
                    >
                  </div>
                  <ng-template #checkETARouteDetails>
                    <app-orders-list-delivered
                      *ngIf="
                        item?.orderHeader?.orderType === 'VS' &&
                        item?.orderHeader?.displayOrderStatus ===
                          OrderStatus.DELIVERED &&
                        !!item?.orderHeader?.confirmedDeliveryDate
                      "
                      [orderHeader]="item?.orderHeader"
                      class="delivery-date"
                    ></app-orders-list-delivered>

                    <div
                      *ngIf="
                        !item?.orderHeader?.orderDelivered &&
                        item?.orderHeader?.displayOrderStatus !==
                          OrderStatus.DELIVERED
                      "
                      class="delivery-date"
                    >
                      <div class="eta">
                        <span
                          class="date"
                          *ngIf="
                            item?.orderHeader?.deliveryEta &&
                              isValidDate(item?.orderHeader?.deliveryEta) &&
                              !(
                                hideEtaGlobalFeatureFlag &&
                                item?.orderHeader?.hideEta
                              );
                            else deliveryDateAsETA
                          "
                        >
                          {{ 'i18n.orderStatusPage.eta' | translate }}
                          {{
                            item.orderHeader?.deliveryEta
                              | date: 'M/d' : item.customer?.timeZone
                          }}
                        </span>
                        <ng-template #deliveryDateAsETA>
                          <span
                            *ngIf="
                              isValidDate(item.deliveryDate) &&
                                ((item.orderStatusDisplayEnabled &&
                                  item.orderHeader?.orderType === 'VS') ||
                                  !(
                                    item.orderHeader?.orderType === 'VS' &&
                                    (!!item.orderHeader?.orderTracking
                                      ?.length ||
                                      item.orderHeader?.trackingAvailable)
                                  ));
                              else deliveryDateAsETANotApplicable
                            "
                            class="date"
                          >
                            {{ 'i18n.orderStatusPage.eta' | translate }}
                            {{ item.deliveryDate | date: 'M/d' : 'GMT' }}
                          </span>
                          <ng-template #deliveryDateAsETANotApplicable>
                            <span
                              class="date"
                              *ngIf="
                                !(
                                  item.orderHeader?.orderType === 'VS' &&
                                  (!!item.orderHeader?.orderTracking?.length ||
                                    item.orderHeader?.trackingAvailable)
                                )
                              "
                            >
                              {{
                                'i18n.orderStatusPage.notApplicable' | translate
                              }}
                            </span>
                          </ng-template>
                        </ng-template>
                        <br />
                        <ng-container
                          *ngIf="
                            !(
                              hideEtaGlobalFeatureFlag &&
                              item?.orderHeader?.hideEta
                            )
                          "
                        >
                          <span
                            class="date"
                            *ngIf="!!item?.orderHeader?.customerStop"
                          >
                            {{ 'i18n.orderStatusPage.youAreStop' | translate }}
                            {{ item?.orderHeader?.customerStop }}
                          </span>
                          <span
                            class="date"
                            *ngIf="!!item?.orderHeader?.etaRoute"
                          >
                            {{ 'i18n.orderStatusPage.onRoute' | translate }}
                            {{ item?.orderHeader?.etaRoute }}
                          </span>
                          <span
                            class="date"
                            *ngIf="
                              !!item?.orderHeader?.currentStop &&
                              item?.orderHeader?.etaMessageType !==
                                orderETAMessageType.PLANNED &&
                              (!!item?.orderHeader?.customerStop ||
                                !!item?.orderHeader?.etaRoute)
                            "
                            >,</span
                          >
                          <span
                            class="date"
                            *ngIf="
                              !!item?.orderHeader?.currentStop &&
                              item?.orderHeader?.etaMessageType !==
                                orderETAMessageType.PLANNED
                            "
                          >
                            {{ 'i18n.orderStatusPage.truckAtStop' | translate
                            }}{{ item?.orderHeader?.currentStop }}</span
                          >
                        </ng-container>
                      </div>
                    </div>
                  </ng-template>
                  <div
                    *ngIf="
                      item.orderDelivered &&
                      !item.deliveredDtm &&
                      item.deliveryDate !== 'Invalid Date' &&
                      item.displayType !== DisplayType.NO_ORDER &&
                      item.deliveryDate !== 'N/A'
                    "
                    data-cy="open-order-item-link"
                    class="delivery-date date"
                  >
                    {{ item.deliveryDate | date: 'M/d' : 'GMT' }}
                  </div>
                  <div
                    *ngIf="
                      item.orderDelivered &&
                      item.deliveredDtm &&
                      item.deliveryDate !== 'Invalid Date' &&
                      item.displayType !== DisplayType.NO_ORDER &&
                      item.deliveryDate !== 'N/A' &&
                      hideEtaGlobalFeatureFlag &&
                      item?.orderHeader?.hideEta
                    "
                    data-cy="open-order-item-link"
                    class="delivery-date date"
                  >
                    {{ 'i18n.orderStatusPage.eta' | translate }}
                    {{ item.deliveryDate | date: 'M/d' : 'GMT' }}
                  </div>
                  <div
                    *ngIf="
                      item.orderDelivered &&
                      !item.deliveredDtm &&
                      item.deliveryDate !== 'Invalid Date' &&
                      item.displayType !== DisplayType.NO_ORDER &&
                      item.deliveryDate === 'N/A'
                    "
                    data-cy="open-order-item-link"
                    class="delivery-date"
                  >
                    {{ 'i18n.orderStatusPage.notApplicable' | translate }}
                  </div>
                </div>
              </ng-container>

              <!-- ORDER EXCEPTIONS ROW -->
              <ng-container
                *ngIf="
                  item.displayType === DisplayType.SUBMITTED_WITH_EXCEPTIONS ||
                  item.displayType === DisplayType.ORDER_CANCELLED ||
                  item.displayType === DisplayType.DELIVERY_DELAYED ||
                  item.displayType === DisplayType.DELIVERY_ISSUE
                "
              >
                <div class="order-label">
                  <div class="customer-label">
                    <div>
                      <span
                        class="customer-name"
                        data-cy="order-customer-name-text"
                      >
                        {{ item.customer?.customerName | titlecase }} &nbsp;
                      </span>
                      <span
                        class="customer-number"
                        data-cy="order-customer-number-text"
                      >
                        ({{ item.orderHeader.customerNumber }})
                      </span>
                      <span
                        class="department-number"
                        *ngIf="item.orderHeader.departmentNumber !== 0"
                        data-cy="order-customer-department-text"
                        >,
                        {{
                          'i18n.orderStatusPage.deptNumberMobile' | translate
                        }}
                        ({{ item.orderHeader.departmentNumber }})
                      </span>
                    </div>
                  </div>
                  <div>
                    <strong
                      data-cy="order-exceptions-display-text"
                      class="red-text"
                    >
                      <span>
                        <img
                          [src]="item.iconUrl"
                          alt="Submitted with exceptions"
                          class="order-icon"
                          height="20"
                        />
                      </span>
                      {{ item.displayTitle | translate }}
                      <span
                        *ngIf="item?.orderHeader?.orderType !== 'VS'"
                        data-cy="order-exceptions-order-type-text"
                        class="order-type-text"
                        >&nbsp;| &nbsp;
                        {{
                          getOrderHeaderTxt(item.orderHeader) | translate
                        }}</span
                      >

                      <span
                        *ngIf="item?.orderHeader?.orderType === 'VS'"
                        data-cy="order-exceptions-order-direct-image"
                        class="order-type-text"
                      >
                        &nbsp;|
                        <img
                          src="assets/icon/direct-no-outline.svg"
                          class="direct-icon"
                          alt="Direct Order"
                          height="10"
                        />
                        {{ 'i18n.orderStatusPage.shipping' | translate }}
                      </span>
                    </strong>
                  </div>
                  <!-- DELIVERY DATE / ETA -->
                  <div
                    *ngIf="
                      item.orderDelivered &&
                      !!item.deliveredDtm &&
                      !(hideEtaGlobalFeatureFlag && item?.orderHeader?.hideEta)
                    "
                    data-cy="open-order-item-link"
                    class="delivery-date date"
                  >
                    {{ 'i18n.orderStatusPage.delivered' | translate }}
                    {{
                      item.deliveredDtm
                        | timezoneDate: 'M/D' : item.customer?.timeZone
                    }},
                    {{
                      item.deliveredDtm
                        | timezoneDate
                          : 'h:mm a'
                          : item.customer?.timeZone ?? 'CT'
                          : true
                    }}
                  </div>
                  <div
                    *ngIf="
                      item?.hasETADetails &&
                        item?.orderHeader?.deliveryEta &&
                        isValidDate(item?.orderHeader?.deliveryEta) &&
                        !(
                          hideEtaGlobalFeatureFlag && item?.orderHeader?.hideEta
                        );
                      else checkETARouteDetails
                    "
                    data-cy="open-order-item-link"
                    class="delivery-date"
                  >
                    <span class="date"
                      >{{ 'i18n.orderStatusPage.eta' | translate }}
                      {{
                        item?.orderHeader?.deliveryEta
                          | date: 'M/d' : item.customer?.timeZone
                      }}
                      <b
                        *ngIf="
                          !!item?.orderHeader?.etaRangeMaximum &&
                          !!item?.orderHeader?.etaRangeMinimum
                        "
                        >,
                        {{
                          item?.orderHeader?.etaRangeMinimum
                            | timezoneDate
                              : 'h:mm a'
                              : item.customer?.timeZone ?? 'CT'
                        }}
                        -
                        {{
                          item?.orderHeader?.etaRangeMaximum
                            | timezoneDate
                              : 'h:mm a'
                              : item.customer?.timeZone ?? 'CT'
                              : true
                        }}
                      </b></span
                    ><br />
                    <span
                      class="date"
                      *ngIf="!!item?.orderHeader?.customerStop"
                    >
                      {{ 'i18n.orderStatusPage.youAreStop' | translate }}
                      {{ item?.orderHeader?.customerStop }}
                    </span>
                    <span class="date" *ngIf="!!item?.orderHeader?.etaRoute">
                      {{ 'i18n.orderStatusPage.onRoute' | translate }}
                      {{ item?.orderHeader?.etaRoute }}
                    </span>
                    <span
                      class="date"
                      *ngIf="
                        !!item?.orderHeader?.currentStop &&
                        item?.orderHeader?.etaMessageType !==
                          orderETAMessageType.PLANNED &&
                        (!!item?.orderHeader?.customerStop ||
                          !!item?.orderHeader?.etaRoute)
                      "
                      >,</span
                    >
                    <span
                      class="date"
                      *ngIf="
                        !!item?.orderHeader?.currentStop &&
                        item?.orderHeader?.etaMessageType !==
                          orderETAMessageType.PLANNED
                      "
                    >
                      {{ 'i18n.orderStatusPage.truckAtStop' | translate
                      }}{{ item?.orderHeader?.currentStop }}</span
                    >
                  </div>
                  <ng-template #checkETARouteDetails>
                    <div
                      *ngIf="!item?.orderHeader?.orderDelivered"
                      class="delivery-date"
                    >
                      <div class="eta">
                        <span
                          class="date"
                          *ngIf="
                            item?.orderHeader?.deliveryEta &&
                              isValidDate(item?.orderHeader?.deliveryEta) &&
                              !(
                                hideEtaGlobalFeatureFlag &&
                                item?.orderHeader?.hideEta
                              );
                            else deliveryDateAsETA
                          "
                        >
                          {{ 'i18n.orderStatusPage.eta' | translate }}
                          {{
                            item.orderHeader?.deliveryEta
                              | date: 'M/d' : item.customer?.timeZone
                          }}
                        </span>
                        <ng-template #deliveryDateAsETA>
                          <span
                            *ngIf="
                              isValidDate(item.deliveryDate) &&
                                ((item.orderStatusDisplayEnabled &&
                                  item.orderHeader?.orderType === 'VS') ||
                                  !(
                                    item.orderHeader?.orderType === 'VS' &&
                                    (!!item.orderHeader?.orderTracking
                                      ?.length ||
                                      item.orderHeader?.trackingAvailable)
                                  ));
                              else deliveryDateAsETANotApplicable
                            "
                            class="date"
                          >
                            {{ 'i18n.orderStatusPage.eta' | translate }}
                            {{ item.deliveryDate | date: 'M/d' : 'GMT' }}
                          </span>
                          <ng-template #deliveryDateAsETANotApplicable>
                            <span
                              class="date"
                              *ngIf="
                                !(
                                  item.orderHeader?.orderType === 'VS' &&
                                  (!!item.orderHeader?.orderTracking?.length ||
                                    item.orderHeader?.trackingAvailable)
                                )
                              "
                            >
                              {{
                                'i18n.orderStatusPage.notApplicable' | translate
                              }}
                            </span>
                          </ng-template>
                        </ng-template>
                        <br />
                        <ng-container
                          *ngIf="
                            !(
                              hideEtaGlobalFeatureFlag &&
                              item?.orderHeader?.hideEta
                            )
                          "
                        >
                          <span
                            class="date"
                            *ngIf="!!item?.orderHeader?.customerStop"
                          >
                            {{ 'i18n.orderStatusPage.youAreStop' | translate }}
                            {{ item?.orderHeader?.customerStop }}
                          </span>
                          <span
                            class="date"
                            *ngIf="!!item?.orderHeader?.etaRoute"
                          >
                            {{ 'i18n.orderStatusPage.onRoute' | translate }}
                            {{ item?.orderHeader?.etaRoute }}
                          </span>
                          <span
                            class="date"
                            *ngIf="
                              !!item?.orderHeader?.currentStop &&
                              item?.orderHeader?.etaMessageType !==
                                orderETAMessageType.PLANNED &&
                              (!!item?.orderHeader?.customerStop ||
                                !!item?.orderHeader?.etaRoute)
                            "
                            >,</span
                          >
                          <span
                            class="date"
                            *ngIf="
                              !!item?.orderHeader?.currentStop &&
                              item?.orderHeader?.etaMessageType !==
                                orderETAMessageType.PLANNED
                            "
                          >
                            {{ 'i18n.orderStatusPage.truckAtStop' | translate
                            }}{{ item?.orderHeader?.currentStop }}</span
                          >
                        </ng-container>
                      </div>
                    </div>
                  </ng-template>
                  <div
                    *ngIf="
                      item.orderDelivered &&
                      !item.deliveredDtm &&
                      item.deliveryDate !== 'Invalid Date' &&
                      item.displayType !== DisplayType.NO_ORDER &&
                      item.deliveryDate !== 'N/A'
                    "
                    data-cy="open-order-item-link"
                    class="delivery-date date"
                  >
                    {{ item.deliveryDate | date: 'M/d' : 'GMT' }}
                  </div>
                  <div
                    *ngIf="
                      item.orderDelivered &&
                      item.deliveredDtm &&
                      item.deliveryDate !== 'Invalid Date' &&
                      item.displayType !== DisplayType.NO_ORDER &&
                      item.deliveryDate !== 'N/A' &&
                      hideEtaGlobalFeatureFlag &&
                      item?.orderHeader?.hideEta
                    "
                    data-cy="open-order-item-link"
                    class="delivery-date date"
                  >
                    {{ 'i18n.orderStatusPage.eta' | translate }}
                    {{ item.deliveryDate | date: 'M/d' : 'GMT' }}
                  </div>
                  <div
                    *ngIf="
                      item.orderDelivered &&
                      !item.deliveredDtm &&
                      item.deliveryDate !== 'Invalid Date' &&
                      item.displayType !== DisplayType.NO_ORDER &&
                      item.deliveryDate === 'N/A'
                    "
                    data-cy="open-order-item-link"
                    class="delivery-date"
                  >
                    {{ 'i18n.orderStatusPage.notApplicable' | translate }}
                  </div>
                </div>
              </ng-container>

              <!-- ORDER ERROR ROW -->
              <ng-container
                *ngIf="
                  item.displayType === DisplayType.ORDER_ERROR ||
                  item.displayType === DisplayType.SUBMISSION_ERROR
                "
              >
                <div class="order-label">
                  <div class="customer-label">
                    <div>
                      <span
                        class="customer-name"
                        data-cy="order-customer-name-text"
                      >
                        {{ item.customer?.customerName | titlecase }} &nbsp;
                      </span>
                      <span
                        class="customer-number"
                        data-cy="order-customer-number-text"
                      >
                        ({{ item.orderHeader.customerNumber }})
                      </span>
                      <span
                        class="department-number"
                        *ngIf="item.orderHeader.departmentNumber !== 0"
                        data-cy="order-customer-department-text"
                        >,
                        {{
                          'i18n.orderStatusPage.deptNumberMobile' | translate
                        }}
                        ({{ item.orderHeader.departmentNumber }})
                      </span>
                    </div>
                  </div>
                  <div>
                    <strong
                      data-cy="order-exceptions-display-text"
                      class="red-text"
                    >
                      <span>
                        <img
                          [src]="item.iconUrl"
                          alt="Order Error"
                          class="order-icon"
                          height="20"
                        />
                      </span>
                      {{ item.displayTitle | translate }}
                    </strong>
                  </div>

                  <!-- DELIVERY DATE / ETA -->
                  <div
                    *ngIf="
                      item.orderDelivered &&
                      !!item.deliveredDtm &&
                      !(hideEtaGlobalFeatureFlag && item?.orderHeader?.hideEta)
                    "
                    data-cy="open-order-item-link"
                    class="delivery-date date"
                  >
                    {{ 'i18n.orderStatusPage.delivered' | translate }}
                    {{
                      item.deliveredDtm
                        | timezoneDate: 'M/D' : item.customer?.timeZone
                    }},
                    {{
                      item.deliveredDtm
                        | timezoneDate
                          : 'h:mm a'
                          : item.customer?.timeZone ?? 'CT'
                          : true
                    }}
                  </div>
                  <div
                    *ngIf="
                      item?.hasETADetails &&
                        item?.orderHeader?.deliveryEta &&
                        isValidDate(item?.orderHeader?.deliveryEta) &&
                        !(
                          hideEtaGlobalFeatureFlag && item?.orderHeader?.hideEta
                        );
                      else checkETARouteDetails
                    "
                    data-cy="open-order-item-link"
                    class="delivery-date"
                  >
                    <span class="date"
                      >{{ 'i18n.orderStatusPage.eta' | translate }}
                      {{
                        item?.orderHeader?.deliveryEta
                          | date: 'M/d' : item.customer?.timeZone
                      }}
                      <b
                        *ngIf="
                          !!item?.orderHeader?.etaRangeMaximum &&
                          !!item?.orderHeader?.etaRangeMinimum
                        "
                        >,
                        {{
                          item?.orderHeader?.etaRangeMinimum
                            | timezoneDate
                              : 'h:mm a'
                              : item.customer?.timeZone ?? 'CT'
                        }}
                        -
                        {{
                          item?.orderHeader?.etaRangeMaximum
                            | timezoneDate
                              : 'h:mm a'
                              : item.customer?.timeZone ?? 'CT'
                              : true
                        }}
                      </b></span
                    ><br />
                    <span
                      class="date"
                      *ngIf="!!item?.orderHeader?.customerStop"
                    >
                      {{ 'i18n.orderStatusPage.youAreStop' | translate }}
                      {{ item?.orderHeader?.customerStop }}
                    </span>
                    <span class="date" *ngIf="!!item?.orderHeader?.etaRoute">
                      {{ 'i18n.orderStatusPage.onRoute' | translate }}
                      {{ item?.orderHeader?.etaRoute }}
                    </span>
                    <span
                      class="date"
                      *ngIf="
                        !!item?.orderHeader?.currentStop &&
                        item?.orderHeader?.etaMessageType !==
                          orderETAMessageType.PLANNED &&
                        (!!item?.orderHeader?.customerStop ||
                          !!item?.orderHeader?.etaRoute)
                      "
                      >,</span
                    >
                    <span
                      class="date"
                      *ngIf="
                        !!item?.orderHeader?.currentStop &&
                        item?.orderHeader?.etaMessageType !==
                          orderETAMessageType.PLANNED
                      "
                    >
                      {{ 'i18n.orderStatusPage.truckAtStop' | translate
                      }}{{ item?.orderHeader?.currentStop }}</span
                    >
                  </div>
                  <ng-template #checkETARouteDetails>
                    <div
                      *ngIf="!item?.orderHeader?.orderDelivered"
                      class="delivery-date"
                    >
                      <div class="eta">
                        <span
                          class="date"
                          *ngIf="
                            item?.orderHeader?.deliveryEta &&
                              isValidDate(item?.orderHeader?.deliveryEta) &&
                              !(
                                hideEtaGlobalFeatureFlag &&
                                item?.orderHeader?.hideEta
                              );
                            else deliveryDateAsETA
                          "
                        >
                          {{ 'i18n.orderStatusPage.eta' | translate }}
                          {{
                            item.orderHeader?.deliveryEta
                              | date: 'M/d' : item.customer?.timeZone
                          }}
                        </span>
                        <ng-template #deliveryDateAsETA>
                          <span
                            *ngIf="
                              isValidDate(item.deliveryDate) &&
                                !(
                                  item.orderHeader?.orderType === 'VS' &&
                                  (!!item.orderHeader?.orderTracking?.length ||
                                    item.orderHeader?.trackingAvailable)
                                );
                              else deliveryDateAsETANotApplicable
                            "
                            class="date"
                          >
                            {{ 'i18n.orderStatusPage.eta' | translate }}
                            {{ item.deliveryDate | date: 'M/d' : 'GMT' }}
                            <br />
                          </span>
                          <ng-template #deliveryDateAsETANotApplicable>
                            <span
                              class="date"
                              *ngIf="
                                !(
                                  item.orderHeader?.orderType === 'VS' &&
                                  (!!item.orderHeader?.orderTracking?.length ||
                                    item.orderHeader?.trackingAvailable)
                                )
                              "
                            >
                              {{
                                'i18n.orderStatusPage.notApplicable' | translate
                              }}
                            </span>
                          </ng-template>
                        </ng-template>
                        <br />
                        <ng-container
                          *ngIf="
                            !(
                              hideEtaGlobalFeatureFlag &&
                              item?.orderHeader?.hideEta
                            )
                          "
                        >
                          <span
                            class="date"
                            *ngIf="!!item?.orderHeader?.customerStop"
                          >
                            {{ 'i18n.orderStatusPage.youAreStop' | translate }}
                            {{ item?.orderHeader?.customerStop }}
                          </span>
                          <span
                            class="date"
                            *ngIf="!!item?.orderHeader?.etaRoute"
                          >
                            {{ 'i18n.orderStatusPage.onRoute' | translate }}
                            {{ item?.orderHeader?.etaRoute }}
                          </span>
                          <span
                            class="date"
                            *ngIf="
                              !!item?.orderHeader?.currentStop &&
                              item?.orderHeader?.etaMessageType !==
                                orderETAMessageType.PLANNED &&
                              (!!item?.orderHeader?.customerStop ||
                                !!item?.orderHeader?.etaRoute)
                            "
                            >,</span
                          >
                          <span
                            class="date"
                            *ngIf="
                              !!item?.orderHeader?.currentStop &&
                              item?.orderHeader?.etaMessageType !==
                                orderETAMessageType.PLANNED
                            "
                          >
                            {{ 'i18n.orderStatusPage.truckAtStop' | translate
                            }}{{ item?.orderHeader?.currentStop }}</span
                          >
                        </ng-container>
                      </div>
                    </div>
                  </ng-template>
                  <div
                    *ngIf="
                      item.orderDelivered &&
                      !item.deliveredDtm &&
                      item.deliveryDate !== 'Invalid Date' &&
                      item.displayType !== DisplayType.NO_ORDER &&
                      item.deliveryDate !== 'N/A'
                    "
                    data-cy="open-order-item-link"
                    class="delivery-date date"
                  >
                    {{ item.deliveryDate | date: 'M/d' : 'GMT' }}
                  </div>
                  <div
                    *ngIf="
                      item.orderDelivered &&
                      item.deliveredDtm &&
                      item.deliveryDate !== 'Invalid Date' &&
                      item.displayType !== DisplayType.NO_ORDER &&
                      item.deliveryDate !== 'N/A' &&
                      hideEtaGlobalFeatureFlag &&
                      item?.orderHeader?.hideEta
                    "
                    data-cy="open-order-item-link"
                    class="delivery-date date"
                  >
                    {{ 'i18n.orderStatusPage.eta' | translate }}
                    {{ item.deliveryDate | date: 'M/d' : 'GMT' }}
                  </div>
                  <div
                    *ngIf="
                      item.orderDelivered &&
                      !item.deliveredDtm &&
                      item.deliveryDate !== 'Invalid Date' &&
                      item.displayType !== DisplayType.NO_ORDER &&
                      item.deliveryDate === 'N/A'
                    "
                    data-cy="open-order-item-link"
                    class="delivery-date"
                  >
                    {{ 'i18n.orderStatusPage.notApplicable' | translate }}
                  </div>
                </div>
              </ng-container>
            </div>

            <div class="bottom-row">
              <ng-container *ngIf="item.displayType !== DisplayType.NO_ORDER">
                <!-- ORDER NUMBER AND PO -->
                <div
                  data-cy="no-order-number-empty-text"
                  class="order-number-and-po"
                >
                  {{ 'i18n.orderStatusPage.orderPlaced' | translate }}
                  <ng-container
                    *ngIf="
                      item.orderHeader.orderDate && item.orderHeader.entryDtm
                    "
                  >
                    {{
                      item.orderHeader.entryDtm
                        | formatDateWithZeroOffset
                        | date: 'M/d/yy' : 'GMT'
                    }}
                  </ng-container>
                  <ng-container
                    *ngIf="
                      item.orderHeader.orderDate && !item.orderHeader.entryDtm
                    "
                  >
                    {{ item.orderHeader.orderDate | date: 'M/d/yy' : 'GMT' }}
                  </ng-container>

                  <ng-container
                    *ngIf="
                      !item.orderHeader.orderDate &&
                      item.displayType !== DisplayType.NO_ORDER
                    "
                    >-</ng-container
                  >
                  <br />
                  {{ 'i18n.orderStatusPage.orderNumber' | translate }}
                  {{
                    item.displayType === DisplayType.NO_ORDER
                      ? ''
                      : item.orderHeader.tandemOrderNumber || '-'
                  }}
                  <br />
                  <ng-container *ngIf="item.orderHeader.purchaseOrderNumber">
                    PO #: {{ item.orderHeader.purchaseOrderNumber }}
                  </ng-container>
                  <ng-container *ngIf="!item.orderHeader.purchaseOrderNumber">
                    PO #: --
                  </ng-container>
                </div>

                <!-- ORDER UNITS AND EACHES -->
                <div
                  data-cy="order-total-units-and-eaches-text"
                  class="order-number-and-po"
                >
                  {{ 'i18n.orderPage.ordered' | translate }}
                  {{ item.tallies?.totalCasesOrdered || '0' }} CS /
                  {{ item.tallies?.totalEachesOrdered || '0' }} EA
                  <br />
                  {{ 'i18n.orderPage.reserved' | translate }}
                  <span
                    class="reserved"
                    [class.red-text]="
                      item.tallies?.totalCasesReserved !==
                      item.tallies?.totalCasesOrdered
                    "
                    >{{ item.tallies?.totalCasesReserved || '0' }} CS</span
                  >
                  /
                  <span
                    class="reserved"
                    [class.red-text]="
                      item.tallies?.totalEachesReserved !==
                      item.tallies?.totalEachesOrdered
                    "
                    >{{ item.tallies?.totalEachesReserved || '0' }} EA
                  </span>
                  <!-- PRICE -->
                  <ng-container
                    *ngIf="
                      item.customer?.ogPrintPriceInd !== 'N' ||
                        item.displayType === DisplayType.NO_ORDER;
                      else noPriceCustomer
                    "
                  >
                    <div
                      data-cy="no-order-total-price-text"
                      class="order-number-and-po"
                    >
                      {{ 'i18n.orderPage.total' | translate }}
                      {{
                        item.displayType === DisplayType.NO_ORDER
                          ? ''
                          : (item.totalPrice | currency) || '-'
                      }}
                    </div>
                  </ng-container>

                  <ng-template #noPriceCustomer>
                    <div>
                      {{ 'i18n.orderStatusPage.notApplicable' | translate }}
                    </div>
                  </ng-template>
                </div>
              </ng-container>

              <!-- SPACE FOR ELLIPSIS - Not Implemented Yet-->
              <div class="ellipsis"></div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>

<!-- PAST ORDER ROW
-->
<div class="order-list" *ngIf="pastOrders">
  <ng-container
    *cdkVirtualFor="
      let orderRow of customerOrdersList?.pastOrdersRows;
      let i = index;
      trackBy: trackItem
    "
  >
    <div #orders>
      <ng-container *ngIf="orderRow?.rowType === rowType.TitleRow" tabindex="0"
        ><div class="date-container" data-cy="order-date-text">
          {{ 'i18n.orderStatusPage.pastOrders' | translate }}
          <ion-badge class="past">{{ orderRow.itemCount }}</ion-badge>
        </div>
      </ng-container>

      <ng-container
        *ngIf="orderRow?.rowType === rowType.OrderRow"
        class="list-container"
        tabindex="0"
      >
        <div
          id="past-orders"
          class="order-list-container order-submitted-green"
          data-cy="open-no-order-link"
          (click)="openCopyOrderModalEmit($event, orderRow)"
        >
          <!-- LINKS -->
          <div
            *ngIf="
              orderRow.displayType !== DisplayType.ORDER_CANCELLED ||
              orderRow.orderHeader?.orderType !== 'VS'
            "
            class="action-link-group"
          >
            <div>&nbsp;</div>
            <!-- QUICKVIEW LINK -->
            <a class="action-link" data-cy="quickview-link">
              {{ 'i18n.common.quickView' | translate }}
            </a>
          </div>

          <div class="order-row-container">
            <div class="customer-and-action-container">
              <!-- ORDER ROW -->
              <div class="order-label">
                <div class="customer-label">
                  <div>
                    <span
                      class="customer-name"
                      data-cy="order-customer-name-text"
                    >
                      {{ orderRow.customer?.customerName | titlecase }} &nbsp;
                    </span>
                    <span
                      class="customer-number"
                      data-cy="order-customer-number-text"
                    >
                      ({{ orderRow.orderHeader.customerNumber }})
                    </span>
                    <span
                      class="department-number"
                      *ngIf="orderRow.orderHeader.departmentNumber !== 0"
                      data-cy="order-customer-department-text"
                      >,
                      {{ 'i18n.orderStatusPage.deptNumberMobile' | translate }}
                      ({{ orderRow.orderHeader.departmentNumber }})
                    </span>
                  </div>
                </div>
                <div>
                  <strong
                    data-cy="order-submitted-display-text"
                    class="green-text"
                  >
                    <span
                      *ngIf="orderRow?.orderHeader?.orderType !== 'VS'"
                      data-cy="order-submitted-order-type-text"
                      class="order-type-text"
                    >
                      {{ getOrderHeaderTxt(orderRow.orderHeader) | translate }}
                    </span>
                    <span
                      *ngIf="orderRow?.orderHeader?.orderType === 'VS'"
                      data-cy="order-exceptions-order-direct-image"
                      class="order-type-text"
                    >
                      <img
                        src="assets/icon/direct-no-outline.svg"
                        class="direct-icon"
                        alt="Direct Order"
                        height="10"
                      />
                      {{ 'i18n.orderStatusPage.shipping' | translate }}
                    </span>
                  </strong>
                </div>
              </div>
            </div>

            <div class="bottom-row">
              <ng-container
                *ngIf="orderRow.displayType !== DisplayType.NO_ORDER"
              >
                <!-- ORDER NUMBER AND PO -->
                <div
                  data-cy="no-order-number-empty-text"
                  class="order-number-and-po"
                >
                  {{ 'i18n.orderStatusPage.orderPlaced' | translate }}
                  <ng-container
                    *ngIf="
                      orderRow.orderHeader.orderDate &&
                      orderRow.orderHeader.entryDtm
                    "
                  >
                    {{
                      orderRow.orderHeader.entryDtm
                        | formatDateWithZeroOffset
                        | date: 'M/d/yy' : 'GMT'
                    }}
                  </ng-container>
                  <ng-container
                    *ngIf="
                      orderRow.orderHeader.orderDate &&
                      !orderRow.orderHeader.entryDtm
                    "
                  >
                    {{
                      orderRow.orderHeader.orderDate | date: 'M/d/yy' : 'GMT'
                    }}
                  </ng-container>

                  <ng-container *ngIf="!orderRow.orderHeader.orderDate"
                    >-</ng-container
                  >
                  <br />
                  {{ 'i18n.orderStatusPage.orderNumber' | translate }}
                  {{ orderRow.orderHeader.tandemOrderNumber || '-' }}
                  <br />
                  <ng-container
                    *ngIf="orderRow.orderHeader.purchaseOrderNumber"
                  >
                    PO #: {{ orderRow.orderHeader.purchaseOrderNumber }}
                  </ng-container>
                  <ng-container
                    *ngIf="!orderRow.orderHeader.purchaseOrderNumber"
                  >
                    PO #: --
                  </ng-container>
                </div>

                <!-- ORDER UNITS AND EACHES -->
                <div
                  data-cy="order-total-units-and-eaches-text"
                  class="order-number-and-po"
                >
                  {{ 'i18n.orderPage.ordered' | translate }}
                  <ng-container
                    *ngIf="
                      orderRow.orderHeader.totalUnits > 0 ||
                      orderRow.orderHeader.totalEaches > 0
                    "
                  >
                    {{ orderRow.orderHeader.totalUnits || '0' }} CS /
                    {{ orderRow.orderHeader.totalEaches || '0' }} EA
                  </ng-container>
                  <ng-container
                    *ngIf="
                      !orderRow.orderHeader.totalUnits &&
                      !orderRow.orderHeader.totalEaches
                    "
                  >
                    -
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
